import * as React from 'react';
import { useMemo, useCallback } from 'react';
import { Avatar } from 'flowbite-react';

import { cn, useModal } from '@restworld/utils-common';

import { RatingChart, MobileModal } from '../../';
import { Heading, Text } from '@restworld/ui-ds-base';
import { ArrowTrendingUpIcon } from '@heroicons/react/24/outline';
import { tertiaryItemListProps } from './list.constants';

export const ListTertiary: React.FunctionComponent<IListTertiaryProps> = ({
  jobPerformanceItemList = [],
  careerPossibilityDescription,
}) => {
  const { listElement, show, close } = usePerformanceList({
    jobPerformanceItemList,
    showModal: Boolean(careerPossibilityDescription),
  });
  const modal = useMemo(
    () => (
      <MobileModal show={show} close={close}>
        <ModalContent>
          <span className="flex items-center justify-center gap-1">
            <ArrowTrendingUpIcon className="h-6 w-6" />
            <Heading size={5} align="center" className="text-lg">{`Possibilità di carriera`}</Heading>
          </span>
          <Text>{careerPossibilityDescription}</Text>
        </ModalContent>
      </MobileModal>
    ),
    [careerPossibilityDescription, close, show]
  );
  return (
    <ListWrapper>
      {listElement}
      {modal}
    </ListWrapper>
  );
};
export default ListTertiary;
// --> parent > styled components
const commonStyle = `flex flex-col gap-4`;
const ModalContent = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn(`px-3 pb-3 ${commonStyle}`, className)} {...props} />
);
const ListWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <ul className={cn(commonStyle, className)} {...props} />
);
const ItemWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <li className={cn('', className)} {...props} />
);
const ImageIconWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <span className={cn('', className)} {...props} />
);
const ImageTitleWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-row gap-2 items-center', className)} {...props} />
);
const ItemEventWrapper = ({ hasChild, className, ...props }: any) => (
  <a
    className={cn(
      'flex flex-row gap-4 items-center justify-between',
      hasChild ? 'pointer-events-auto' : 'pointer-events-none',
      className
    )}
    {...props}
  />
);
const ItemContent = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('[flex-shrink:10]', className)} {...props} />
);
const AvatarStyled = Avatar;
// --> types
interface IListTertiaryProps {
  jobPerformanceItemList: tertiaryItemListProps[];
  careerPossibilityDescription?: string;
}
const usePerformanceList = ({
  jobPerformanceItemList,
  showModal,
}: {
  jobPerformanceItemList: tertiaryItemListProps[];
  showModal: boolean;
}) => {
  const { show, close, open } = useModal();
  const clickHandler = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault();
      open();
    },
    [open]
  );
  const listElement = useMemo(
    () =>
      jobPerformanceItemList.map(({ title, subTitle, hasChild, key, rating, icon }) => {
        const isModalShow = hasChild && showModal;
        let iconEl = null;
        if (rating) iconEl = <RatingChart rating={rating} icon={icon} />;
        if (key === 'recruiter-profile') iconEl = <AvatarStyled rounded img={icon} size="lg" />;
        return (
          <ItemWrapper key={key}>
            <ItemEventWrapper href="#!" hasChild={isModalShow} onClick={clickHandler}>
              <ImageTitleWrapper>
                {iconEl ? <ImageIconWrapper>{iconEl}</ImageIconWrapper> : null}
                <ItemContent>
                  <Heading as="span" size={5}>
                    {title}
                  </Heading>
                  <Heading as="span" size={5} weight="normal" color="muted">
                    {subTitle || ''}
                  </Heading>
                </ItemContent>
              </ImageTitleWrapper>
              {/* {isModalShow && <Button icon="ChevronRightIcon" variant="ghost" />} */}
            </ItemEventWrapper>
          </ItemWrapper>
        );
      }),
    [jobPerformanceItemList, showModal, clickHandler]
  );
  return {
    show,
    close,
    listElement,
  };
};
